import { createFileRoute } from "@tanstack/react-router";
import { permanentRedirect } from "@/lib/routeRedirect";

// Deprecated product name. Answered with a real 301 on the server, preserving
// query and hash, so old links and bookmarks land on the current page.
export const Route = createFileRoute("/products/inception")({
  beforeLoad: permanentRedirect("/products/agentic-enterprise-platform"),
});
